import { LAST_NAME } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { Rule } from 'antd/es/form';
import { Form, Input, InputProps } from 'antd';

const rules: Rule[] = [
	{
		message: LAST_NAME.REQUIRED_MESSAGE,
		min: LAST_NAME.MIN_LENGTH,
		pattern: LAST_NAME.PATTERN,
		required: true,
		type: 'string'
	}
];

export interface LastNameProps extends InputProps {
	id?: string;
	label?: string;
	name?: string;
}

export const LastName: React.FC<LastNameProps> = ({ id, label, name = 'lastName', ...props }) =>
	<Form.Item
		id={ id }
		label={ label }
		name={ name }
		rules={ rules }>
		<Input
			{ ...props }
			placeholder={ LAST_NAME.PLACEHOLDER }
			type='text' />
	</Form.Item>;


